"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLegacyProps = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var SizeContext_1 = tslib_1.__importDefault(require("../config-provider/SizeContext"));
var reactNode_1 = require("../util/reactNode");
var types_1 = require("../util/types");
var button_group_1 = tslib_1.__importDefault(require("./button-group"));
var LoadingIcon_1 = tslib_1.__importDefault(require("./LoadingIcon"));
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
function isUnborderedButtonType(type) {
    return type === 'text' || type === 'link';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child) {
    // Check the child if is undefined or null.
    if (child === null) {
        return;
    }
    var SPACE = '';
    // strictNullChecks oops.
    if (typeof child !== 'string' &&
        typeof child !== 'number' &&
        isString(child.type) &&
        isTwoCNChar(child.props.children)) {
        return (0, reactNode_1.cloneElement)(child, {
            children: child.props.children.split('').join(SPACE),
        });
    }
    if (typeof child === 'string') {
        if (isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
        }
        return React.createElement("span", null, child);
    }
    return child;
}
function spaceChildren(children) {
    var isPrevChildPure = false;
    var childList = [];
    React.Children.forEach(children, function (child) {
        var type = typeof child;
        var isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            var lastIndex = childList.length - 1;
            var lastChild = childList[lastIndex];
            childList[lastIndex] = "".concat(lastChild).concat(child);
        }
        else {
            childList.push(child);
        }
        isPrevChildPure = isCurrentChildPure;
    });
    // Pass to React.Children.map to auto fill key
    return React.Children.map(childList, function (child) { return insertSpace(child); });
}
var ButtonTypes = (0, types_1.tuple)('default', 'primary', 'ghost', 'dashed', 'link', 'text', 'second', 'third', 'fourth');
var ButtonShapes = (0, types_1.tuple)('circle', 'round');
var ButtonHTMLTypes = (0, types_1.tuple)('submit', 'button', 'reset');
function convertLegacyProps(type) {
    if (type === 'danger') {
        return { danger: true };
    }
    return { type: type };
}
exports.convertLegacyProps = convertLegacyProps;
var InternalButton = function (props, ref) {
    var _a;
    var _b = props.loading, loading = _b === void 0 ? false : _b, customizePrefixCls = props.prefixCls, type = props.type, danger = props.danger, shape = props.shape, customizeSize = props.size, className = props.className, children = props.children, icon = props.icon, _c = props.ghost, ghost = _c === void 0 ? false : _c, _d = props.block, block = _d === void 0 ? false : _d, 
    /** If we extract items here, we don't need use omit.js */
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    _e = props.htmlType, 
    /** If we extract items here, we don't need use omit.js */
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = _e === void 0 ? 'button' : _e, rest = tslib_1.__rest(props, ["loading", "prefixCls", "type", "danger", "shape", "size", "className", "children", "icon", "ghost", "block", "htmlType"]);
    var size = React.useContext(SizeContext_1.default);
    var _f = tslib_1.__read(React.useState(!!loading), 2), innerLoading = _f[0], setLoading = _f[1];
    // const [hasTwoCNChar, setHasTwoCNChar] = React.useState(false);
    var _g = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _g.getPrefixCls, direction = _g.direction;
    var buttonRef = ref || React.createRef();
    var delayTimeoutRef = React.useRef();
    // const isNeedInserted = () =>
    //   React.Children.count(children) === 1 && !icon && !isUnborderedButtonType(type);
    // const fixTwoCNChar = () => {
    //   // Fix for HOC usage like <FormatMessage />
    //   if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) {
    //     return;
    //   }
    //   const buttonText = buttonRef.current.textContent;
    //   if (isNeedInserted() && isTwoCNChar(buttonText)) {
    //     if (!hasTwoCNChar) {
    //       setHasTwoCNChar(true);
    //     }
    //   } else if (hasTwoCNChar) {
    //     setHasTwoCNChar(false);
    //   }
    // };
    // =============== Update Loading ===============
    var loadingOrDelay;
    if (typeof loading === 'object' && loading.delay) {
        loadingOrDelay = loading.delay || true;
    }
    else {
        loadingOrDelay = !!loading;
    }
    React.useEffect(function () {
        clearTimeout(delayTimeoutRef.current);
        if (typeof loadingOrDelay === 'number') {
            delayTimeoutRef.current = window.setTimeout(function () {
                setLoading(loadingOrDelay);
            }, loadingOrDelay);
        }
        else {
            setLoading(loadingOrDelay);
        }
    }, [loadingOrDelay]);
    // React.useEffect(fixTwoCNChar, [buttonRef]);
    var handleClick = function (e) {
        var onClick = props.onClick;
        if (innerLoading) {
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };
    var prefixCls = getPrefixCls('btn', customizePrefixCls);
    // const autoInsertSpace = autoInsertSpaceInButton !== false;
    // large => lg
    // small => sm
    var sizeCls = '';
    switch (customizeSize || size) {
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        default:
            break;
    }
    var iconType = innerLoading ? 'loading' : icon;
    var classes = (0, classnames_1.default)(prefixCls, (_a = {},
        _a["".concat(prefixCls, "-").concat(type)] = type,
        _a["".concat(prefixCls, "-").concat(shape)] = shape,
        _a["".concat(prefixCls, "-").concat(sizeCls)] = sizeCls,
        _a["".concat(prefixCls, "-icon-only")] = !children && children !== 0 && iconType,
        _a["".concat(prefixCls, "-background-ghost")] = ghost && !isUnborderedButtonType(type),
        _a["".concat(prefixCls, "-loading")] = innerLoading,
        // [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && autoInsertSpace,
        _a["".concat(prefixCls, "-block")] = block,
        _a["".concat(prefixCls, "-dangerous")] = !!danger,
        _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _a), className);
    var iconNode = icon && !innerLoading ? (React.createElement("span", { className: sizeCls
            ? "".concat(prefixCls, "-icon-position ").concat(prefixCls, "-").concat(sizeCls, "-size")
            : "".concat(prefixCls, "-icon-position") }, icon)) : (React.createElement(LoadingIcon_1.default, { existIcon: !!icon, prefixCls: prefixCls, loading: !!innerLoading }));
    var kids = children || children === 0 ? spaceChildren(children) : null;
    var linkButtonRestProps = (0, omit_1.default)(rest, ['navigate']);
    if (linkButtonRestProps.href !== undefined) {
        return (React.createElement("a", tslib_1.__assign({}, linkButtonRestProps, { className: classes, onClick: handleClick, ref: buttonRef }),
            iconNode,
            kids));
    }
    var buttonNode = (React.createElement("button", tslib_1.__assign({}, rest, { type: htmlType, className: classes, onClick: handleClick, ref: buttonRef }),
        iconNode,
        kids));
    if (isUnborderedButtonType(type)) {
        return buttonNode;
    }
    return React.createElement(React.Fragment, null, buttonNode);
};
var Button = React.forwardRef(InternalButton);
Button.displayName = 'Button';
Button.Group = button_group_1.default;
Button.__ANT_BUTTON = true;
exports.default = Button;
//# sourceMappingURL=button.js.map